import axios from "axios";

import constants from "../../constants";

/**
 * Sugestões de recursos (o botão "Sugira um recurso ou ideia" das Novidades). A API guarda, avisa o time por e-mail e repassa
 * ao Operations, onde o time acompanha cada uma (contrato: api-keepo-v2's POST suggestions).
 */

export const MAX_SUGGESTION_LENGTH = 1000;

/** The API's rate limit (a few suggestions per person in a few minutes): trying again right away fails again. */
export const isTooManySuggestions = (error: unknown) => axios.isAxiosError(error) && error.response?.status === 429;

export const sendSuggestion = async (message: string, lang: string, siteId?: string): Promise<void> => {
  await axios.post(`${constants.api}/suggestions`, { message, lang, siteId: siteId ?? null });
};
